import React from "react";
import SettlementCard from "./SettlementCard";
import PropTypes from "prop-types";
import FullscreenLoader from "../loadings/FullscreenLoader";
// import { apollo_logo } from "../imagepath";

function SettlementList(props) {
  const { data, loading } = props;
  if (loading) {
    return <FullscreenLoader />;
  }
  
  return (
    <div className="row mt-2">
      {data?.length > 0 ? (
        data.map((item) => (
          <div className="col-sm-6 col-lg-4 col-xl-4 d-flex" key={item.id}>
            <SettlementCard data={item} />
          </div>
        ))
      ) : (
        <div className="no-content-box d-flex flex-column justify-content-center align-items-center py-5">
          <div className="mb-3">
            <i className="fas fa-file-invoice-dollar text-muted" style={{ fontSize: '48px' }}></i>
          </div>
          <h5 className="text-muted mb-2">No Settlements Found</h5>
          {/* <p className="text-secondary mb-0">Try adjusting your search criteria or check back later</p> */}
        </div>
      )}
    </div>
  );
}

SettlementList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};

export default SettlementList;
